<div class="skills-row">
  <div class="skills-row__cards-group">
    <app-skill-card *ngFor="let skill of skills" [skill]="skill" (skillDetail)="renderDetails($event)"></app-skill-card>
  </div>
  <app-skill-detail [skillDetail]="skillDetail" *ngIf="skillDetail != null" [@accordionAnimation]="accordionAnimation">
  </app-skill-detail>
</div>
